import React, { Component } from 'react'
import { connect } from 'react-redux'

import '@/companys/eif/assets/styles/components/copy-right/copy-right.scss'

const disclaimerHrefs = window?.config?.companyOptions?.disclaimer

class CopyRight extends Component {
  render() {
    const { language } = this.props
    return (
      <div className='copy-right'>
        <p>
          {language.common_recommend_text} <span className='phone'>{language.common_recommend_phoneI}</span> {language.common_recommend_or}&nbsp;&nbsp;
          <span className='phone'>{language.common_recommend_phoneII}</span>
        </p>
        <p>
          {language.common_copyright} |&nbsp;&nbsp;
          <a className='text-disclaimer' target='_blank' href={disclaimerHrefs?.[language.lang] || '#'}>
            {language.common_disclaimer}
          </a>
        </p>
      </div>
    )
  }
}

export default connect(state => ({ language: state.app.language }))(CopyRight)
